export function Config() {
  this.apiUrl = "https://gx0m09tai2.execute-api.eu-west-1.amazonaws.com/";
}

